export default __webpack_public_path__ + "static/media/IMG-20190601-WA0002.b3ecc786.jpg";